<template>
  <section class="content">
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
        >
          <router-link :to="{ name: 'VehicleCreate' }">
            <button class="btn">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="vehicleTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState } from 'vuex';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import {authService,filterService, vehicleService } from '../../../services'

export default {
  name: 'Vehicle',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      vehicleTable: null,
      regionData :'',
      region :{},
      params:{},
      columns: ['regNo', 'capacity', 'ownerName', 'transportSupervisorContact','transportSupervisorName', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['regNo', 'capacity', 'ownerName', 'transportSupervisorContact','transportSupervisorName', 'status'],
        headings: {
          regNo: 'Registration No',
          capacity: 'Capacity (kg)',
          ownerName: 'Transporter Name',
          transportSupervisorContact: 'Transport Supervisor Contact',
          transportSupervisorName: 'Transport Supervisor Name',
          status: 'Status',
        },

        templates: {
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
        },
        // customFilters: [{
        // 	name: 'alphabet',
        // 	callback: function(row, query) {
        // 		//return row.name[0] == query;
        // 		console.log('test', query);
        // 	}
        // }],
        requestFunction: request => {
          this.params.$page = request.page;
          this.params.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            this.params.regionRegionManager = this.user._id
          }
          // if(this.user.roleName == "Journey Manager"){
          //   this.params.regionJourneyManager = this.user._id
          // }
          if (request.orderBy) {
            this.params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          }
          if (request.query) {
            this.params.$term = request.query;
          }
          else{
            delete this.params.$term
          }
          if (request.query.status) {
            this.params.status = request.query.status;
          }
          this.loading = true;
          return this.$vehicleDataRepository.list(this.params).catch(error => {
            console.error('Vehicle.requestFunction-error:', error);
            this.$snotify.error('Get Vehicle', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.vehicleTable) {
        return this.vehicleTable.count > this.vehicleTable.limit ||
          this.vehicleTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
      
    }),

  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'VehicleDetail',
        params: { _id: data.row._id },
        props: data.row,
      });
    },
    onLoaded() {
      this.vehicleTable = this.$refs.vehicleTable;
    },
    // getRegions(){
    //   console.log("vghvhgyvfytvytfv")
    //   let regionId
    //   this.$regionDataRepository.list()
    //     .then((response) => {
    //       this.regionData =
    //         response.data &&
    //         response.data.docs &&
    //         response.data.docs.filter(item => item.regionManager == this.user._id);
    //         console.log("this.region",this.regionData)
    //         this.regionId = this.regionData && this.regionData.map(item => item._id )
    //         console.log("this.regionId",this.regionId[0])
    //         this.params = {
    //           ...this.params,
    //           region : this.regionId[0],
    //         };
    //         console.log("parrrrrrrr",this.params)
    //     })
    // }
  },
}
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn {
   background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
        color: white
}
</style>





// WEBPACK FOOTER //
// Vehicles.vue?49467deb